<template>
  <!--
  作者：luoyiming
  时间：2019-10-24
  描述：科室介绍
  -->
  <div>
    <!--nav start-->
    <div id="nav">
      <ul class="nav">
        <li :class="routerstr.indexOf('index') != -1 ? 'active' : ''" @click="pageClick('/index')">首页</li>
        <li :class="routerstr.indexOf('notice') != -1 ? 'active' : ''" @click="pageClick('/notice')">医院通知</li>
        <li :class="routerstr.indexOf('news') != -1 ? 'active' : ''" @click="pageClick('/news')">新闻中心</li>
        <li :class="routerstr.indexOf('message') != -1 ? 'active' : ''" @click="pageClick('/message')">信息公告</li>
        <li :class="routerstr.indexOf('department') != -1 ? 'active' : ''" @click="pageClick('/department')">科室介绍</li>
        <li :class="routerstr.indexOf('information') != -1 ? 'active' : ''" @click="pageClick('/information')">健康资讯</li>
        <li :class="routerstr.indexOf('contact') != -1 ? 'active' : ''" @click="pageClick('/contact')">联系我们</li>
      </ul>
    </div>
    <!--nav end-->
    <div class="department_title">科室介绍</div>
    <div class="department_list">

      <!--item start-->
      <div class="department_item" v-for="(item, index) in department" :key="index">
        <div class="department_type_title">{{ item.roomTypeName }}</div>
        <div class="department_list_content">
          <p v-for="(i, ind) in item.dto" :key="ind" @click="pageQueryClick('departmentdetail', i.roomId)">
            <span class="department_list_content_text">{{ i.roomName }}</span>
            <span class="department_list_content_right"> ›</span>
          </p>
        </div>
      </div>
      <!--start end-->
    </div>
  </div>
</template>

<script>
import IndexApi from '@/api/index.js';
export default {
  data() {
    return {
      routerstr: '/department',
      /*是否正在加载*/
      loading: true,
      /*背景图片*/
      bgimg_url: '',
      /*是否正在提交*/
      logining: false,
      /*基础配置*/
      department: [],
    };
  },
  created() {
    this.getDepartment();
    this.routerstr = this.$router.currentRoute.path;
  },
  methods: {

    /*页面跳转*/
    pageClick(row) {
      this.$router.push(row);
    },
    /*页面跳转*/
    pageQueryClick(row, id) {
      this.$router.push({ path: row, query: { id: id } });
    },
    getDepartment() {
      let self = this;
      IndexApi.department(true)
        .then(res => {
          self.loading = false;
          self.department = res.data;
        })
        .catch(error => {
          self.loading = false;
        });
    },
  }
};
</script>

<style lang="scss" scoped>
.department_title {
  height: 150px;
  width: 100%;
  background: #007E4F;
  line-height: 150px;
  text-align: center;
  font-size: 36px;
  color: #fff;
  font-weight: bold;
}

.department_list {
  width: 1180px;
  margin: 33px auto;


  .department_item {

    .department_type_title {
      height: 40px;
      line-height: 40px;
      font-size: 28px;
      color: #333;
      margin: 40px 0 10px 0;
    }

    .department_list_content {
      margin: 15px 0 0 0;

      p {
        margin: 20px 20px 0 0;
        cursor: pointer;
        display: inline-block;
        border: 1px solid #ccc;
        border-radius: 5px;

        span.department_list_content_text {
          display: block;
          padding: 9px 36px;
          height: 46px;
          float: left;
          line-height: 28px;
          font-size: 20px;
        }

        span.department_list_content_right {
          font-size: 20px;
          color: #999;
          display: block;
          padding: 8px;
          border-left: 1px solid #ccc;
          height: 46px;
          float: right;
          line-height: 28px;
        }
      }

      p:hover {
        color: #007E4F;
      }

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/department.vue